var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#E6E0FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9500_109796",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9500_109796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 24.4L18.65 21.35L15.6 20L18.65 18.625L20 15.6L21.375 18.625L24.4 20L21.375 21.35L20 24.4ZM20 30.5C18.1333 30.5 16.4127 30.0457 14.838 29.137C13.2627 28.229 11.9833 26.95 11 25.3V28.5H9.5V22.8H15.175V24.3H12.175C12.9917 25.7667 14.0917 26.9167 15.475 27.75C16.8583 28.5833 18.3667 29 20 29C21.95 29 23.7083 28.4293 25.275 27.288C26.8417 26.146 27.9333 24.65 28.55 22.8L30 23.125C29.3167 25.325 28.0543 27.104 26.213 28.462C24.371 29.8207 22.3 30.5 20 30.5ZM9.55 19C9.66667 17.9167 9.91667 16.9123 10.3 15.987C10.6833 15.0623 11.2167 14.175 11.9 13.325L13 14.375C12.4667 15.0583 12.0417 15.7707 11.725 16.512C11.4083 17.254 11.1917 18.0833 11.075 19H9.55ZM14.4 12.975L13.325 11.9C14.175 11.2167 15.079 10.679 16.037 10.287C16.9957 9.89568 17.9833 9.65835 19 9.57501V11.075C18.1667 11.1583 17.3627 11.3623 16.588 11.687C15.8127 12.0123 15.0833 12.4417 14.4 12.975ZM25.6 12.975C24.9667 12.4583 24.246 12.029 23.438 11.687C22.6293 11.3457 21.8167 11.1417 21 11.075V9.57501C22.0333 9.65835 23.0293 9.90001 23.988 10.3C24.946 10.7 25.8417 11.2417 26.675 11.925L25.6 12.975ZM28.925 19C28.825 18.1167 28.6127 17.2873 28.288 16.512C27.9627 15.7373 27.5333 15.025 27 14.375L28.075 13.325C28.7583 14.1417 29.296 15.029 29.688 15.987C30.0793 16.9457 30.325 17.95 30.425 19H28.925Z",
    fill: "#714EF5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.1dcd1509c8f3530696cb028be80bb9b3.svg";
export { ForwardRef as ReactComponent };